import React, { Dispatch, SetStateAction, useState } from 'react';
import FullWidthCard from 'src/components/cards/full-width-card';
import { Box } from '@material-ui/core';
import { Body, Button } from 'src/components/UI';
import Row from 'src/components/Row';

import TermsAndPrivecyAndCaliforniaNoticeDrawer from 'src/components/TermsAndPrivecyAndCaliforniaNoticeDrawer';
import styles from './style.module.scss';

const EsayRewardIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="200"
        height="29"
        viewBox="0 0 200 29"
        fill="none"
    >
        <path
            d="M5.23089 12.7584H13.7893V8.26751H5.23089V4.62124H14.9248V0H2.66664C1.1937 0 0 1.1937 0 2.66664V18.464C0 19.937 1.1937 21.1307 2.66664 21.1307H15.2924V16.4024H5.23089V12.7561V12.7584Z"
            fill="#CC0000"
        />
        <path
            d="M43.0036 11.8602C42.0263 11.4647 41.4981 11.2529 40.6534 10.9085C39.4387 10.4059 39.0688 10.0895 39.0688 9.56125C39.0688 9.00745 39.7552 8.63747 40.7604 8.63747C41.9495 8.63747 43.2432 9.08656 44.5114 9.95916L46.7034 6.86902C45.0396 5.52174 42.6359 4.70267 40.2578 4.70267C36.3486 4.70267 33.7332 6.68287 33.7332 9.61477C33.7332 11.6485 34.8431 13.1819 36.9303 14.0522C37.775 14.3966 38.5685 14.713 39.4132 15.0551C40.786 15.6089 41.2095 15.9533 41.2095 16.4815C41.2095 17.1144 40.5231 17.5379 39.5179 17.5379C38.1706 17.5379 36.5324 16.905 35.134 15.8462L32.942 19.2808C34.7384 20.7607 37.0886 21.5518 39.7296 21.5518C43.9553 21.5518 46.7825 19.5181 46.7825 16.4C46.7825 14.2593 45.7005 12.9399 43.0059 11.8556L43.0036 11.8602Z"
            fill="#CC0000"
        />
        <path
            d="M60.225 5.12384L56.9464 15.3134L53.121 5.12384H47.7854L52.9627 17.1447C48.9977 17.2168 46.3334 19.5739 46.3334 23.0341C46.3334 26.0986 48.8162 28.4232 52.0925 28.4232C55.1291 28.4232 57.1907 26.9968 58.5636 23.9323C59.1453 22.6641 59.4874 21.8985 59.7783 21.133H64.7974V17.1447H61.1674L65.3512 5.12617H60.2273L60.225 5.12384ZM54.3868 22.6106C53.9121 23.6135 53.2769 24.1161 52.4857 24.1161C51.6946 24.1161 51.1128 23.5623 51.1128 22.7153C51.1128 21.7636 51.9854 21.1307 53.2513 21.1307H55.0732C54.8615 21.6333 54.6777 22.0288 54.3868 22.6106Z"
            fill="#CC0000"
        />
        <path
            d="M24.9887 4.70267C22.3197 4.70267 19.8113 5.46822 17.6729 6.94813L19.7322 10.2244C21.2121 9.32623 22.9015 8.79803 24.2743 8.79803C25.9916 8.79803 27.1527 9.53798 27.1527 10.6479V10.7806L22.0545 11.6252C18.5688 12.2069 16.7189 13.9754 16.7189 16.7491C16.7189 19.5227 19.1226 21.5565 22.2918 21.5565C24.272 21.5565 26.1475 20.6327 26.941 19.2854V21.1353H31.8019V10.3315C31.8019 6.634 29.4517 4.70499 24.9864 4.70499L24.9887 4.70267ZM27.1551 13.894C27.1551 16.0859 25.7031 17.7496 23.7997 17.7496C22.7432 17.7496 21.9242 17.0888 21.9242 16.2441C21.9242 15.3459 22.6385 14.713 23.9579 14.4222L27.1551 13.7357V13.894Z"
            fill="#CC0000"
        />
        <path
            d="M89.2278 7.44844C89.2278 2.98543 86.005 0 81.1976 0H74.7521C73.2792 0 72.0854 1.1937 72.0854 2.66664V21.1307H77.3163V15.0016H80.2227L83.6037 21.1307H89.3883L85.4 14.0243C87.8037 12.7561 89.2301 10.2989 89.2301 7.44611L89.2278 7.44844ZM80.2738 10.513H77.3163V4.49094H80.2738C82.5984 4.49094 83.8131 5.52176 83.8131 7.50196C83.8131 9.48216 82.5984 10.513 80.2738 10.513Z"
            fill="#CC0000"
        />
        <path
            d="M188.743 11.8602C187.765 11.4647 187.237 11.2529 186.392 10.9085C185.178 10.4059 184.808 10.0895 184.808 9.56125C184.808 9.00745 185.494 8.63747 186.499 8.63747C187.688 8.63747 188.982 9.08656 190.25 9.95916L192.442 6.86902C190.779 5.52174 188.375 4.70267 185.997 4.70267C182.088 4.70267 179.472 6.68287 179.472 9.61477C179.472 11.6485 180.582 13.1796 182.669 14.0522C183.514 14.3966 184.307 14.713 185.152 15.0551C186.525 15.6089 186.949 15.9533 186.949 16.4815C186.949 17.1144 186.262 17.5379 185.257 17.5379C183.91 17.5379 182.271 16.905 180.873 15.8462L178.681 19.2808C180.477 20.7607 182.828 21.5518 185.469 21.5518C189.694 21.5518 192.521 19.5181 192.521 16.4C192.521 14.2616 191.439 12.9399 188.745 11.8556L188.743 11.8602Z"
            fill="#CC0000"
        />
        <path
            d="M172.233 6.97375C171.098 5.52176 169.434 4.70268 167.242 4.70268C163.067 4.70268 159.926 8.34895 159.926 13.1563C159.926 17.9637 163.07 21.5565 167.242 21.5565C169.355 21.5565 170.939 20.7118 172.207 19.2854V21.1353H177.41V0H172.233V6.97375ZM168.747 16.8003C166.635 16.8003 165.234 15.2948 165.234 13.0493C165.234 10.8038 166.635 9.32393 168.747 9.32393C170.86 9.32393 172.261 10.8294 172.261 13.0493C172.261 15.2692 170.86 16.8003 168.747 16.8003Z"
            fill="#CC0000"
        />
        <path
            d="M98.3143 4.70268C93.5069 4.70268 89.7815 8.32103 89.7815 13.1284C89.7815 17.9358 93.5581 21.5542 98.4981 21.5542C101.272 21.5542 103.571 20.656 105.551 18.8852L102.882 15.7159C101.56 16.8259 100.32 17.3262 98.6563 17.3262C96.6482 17.3262 95.1171 16.0836 95.038 14.499H106.344L106.424 13.5473C107.031 8.4746 103.571 4.69803 98.3143 4.69803V4.70268ZM94.9589 11.5973C95.2497 9.88006 96.597 8.71893 98.3143 8.71893C99.9245 8.71893 101.193 9.88006 101.272 11.5973H94.9589Z"
            fill="#CC0000"
        />
        <path
            d="M197.096 21.5293C198.7 21.2204 199.75 19.6698 199.441 18.0659C199.132 16.462 197.581 15.4121 195.977 15.721C194.373 16.0299 193.324 17.5805 193.632 19.1844C193.941 20.7883 195.492 21.8381 197.096 21.5293Z"
            fill="#CC0000"
        />
        <path
            d="M126.526 5.12384L123.698 14.6083L120.871 5.12384H117.281L114.374 14.6083L111.496 5.12384H106.028L111.626 21.1307H116.117L118.996 12.4676L121.848 21.1307H126.339L131.808 5.12384H126.526Z"
            fill="#CC0000"
        />
        <path
            d="M154.193 7.26461V5.12618H149.015V21.133H154.193V14.0801C154.193 11.4391 155.619 9.85446 158.048 9.85446H159.396V4.65149H158.63C156.913 4.65149 155.514 5.47056 154.193 7.26694V7.26461Z"
            fill="#CC0000"
        />
        <path
            d="M139.717 4.70267C137.048 4.70267 134.54 5.46822 132.401 6.94813L134.46 10.2244C135.94 9.32623 137.63 8.79803 139.003 8.79803C140.72 8.79803 141.881 9.53798 141.881 10.6479V10.7806L136.783 11.6252C133.297 12.2069 131.447 13.9754 131.447 16.7491C131.447 19.5227 133.851 21.5565 137.02 21.5565C139 21.5565 140.876 20.6327 141.669 19.2854V21.1353H146.53V10.3315C146.53 6.634 144.18 4.70499 139.715 4.70499L139.717 4.70267ZM141.883 13.894C141.883 16.0859 140.431 17.7496 138.528 17.7496C137.472 17.7496 136.652 17.0888 136.652 16.2441C136.652 15.3459 137.364 14.713 138.686 14.4222L141.883 13.7357V13.894Z"
            fill="#CC0000"
        />
    </svg>
);

interface IProps {
    setIsEnroll: Dispatch<SetStateAction<string | false>>;
}

const NoEnrollEasyRewardCard = ({ setIsEnroll }: IProps) => {
    const [tosSource, setTosSource] = useState<string | null>(null);
    const [tosTabIndex, setTosTabIndex] = useState(0);
    const [showTabs, setShowTabs] = useState(false);
    return (
        <>
            <FullWidthCard className={styles.noEnrollCard} noPadding>
                <Box
                    sx={{
                        textAlign: 'center',
                    }}
                >
                    <EsayRewardIcon />
                </Box>
                <Row
                    direction="column"
                    gap="10px"
                    sx={{
                        mt: '16px',
                        mb: '20px',
                    }}
                >
                    <>
                        <Box>
                            <Body
                                size={16}
                                lineHeight={20}
                                textAlign="textCenter"
                            >
                                Enroll in Easy Rewards to activate
                            </Body>
                            <Body
                                size={16}
                                lineHeight={20}
                                textAlign="textCenter"
                            >
                                your offers.
                            </Body>
                        </Box>
                        <Button
                            onClick={() => {
                                setIsEnroll(false);
                            }}
                            className={styles.enrollNowButton}
                            id="edit-mode-toggle-button"
                        >
                            Enroll now
                        </Button>
                    </>
                </Row>
                <Box>
                    <Body size={10} weight="light" lineHeight={14}>
                        By enrolling in Easy Rewards, you agree to Staples and
                        Easy
                    </Body>
                    <Box
                        sx={{
                            display: 'ruby',
                            alignItems: 'center',
                        }}
                    >
                        <Body size={10} weight="light" lineHeight={14}>
                            Rewards &nbsp;
                        </Body>
                        <Box
                            onClick={() => {
                                setShowTabs(true);
                                setTosSource(
                                    `${process.env.REACT_APP_DOTCOM_URL}/hc?id=52e40651-0852-4ad7-a532-45017c287d50`
                                );
                            }}
                        >
                            <Body
                                className={styles.linkText}
                                size={10}
                                weight="light"
                                lineHeight={14}
                            >
                                Terms & Conditions
                            </Body>
                        </Box>
                        <Body size={10} weight="light" lineHeight={14}>
                            , &nbsp;
                        </Body>
                        <Box
                            onClick={() => {
                                setTosSource(
                                    `${process.env.REACT_APP_DOTCOM_URL}/hc?id=dbb94c10-973c-478b-a078-00e58f66ba32`
                                );
                            }}
                        >
                            <Body
                                className={styles.linkText}
                                size={10}
                                weight="light"
                                lineHeight={14}
                            >
                                Privacy Notice &nbsp;
                            </Body>
                        </Box>
                        <Body size={10} weight="light" lineHeight={14}>
                            and &nbsp;
                        </Body>
                        <Box
                            onClick={() => {
                                setTosSource(
                                    `${process.env.REACT_APP_DOTCOM_URL}/stores/californianotice`
                                );
                            }}
                        >
                            <Body
                                className={styles.linkText}
                                size={10}
                                weight="light"
                                lineHeight={14}
                            >
                                California Notice
                            </Body>
                        </Box>
                    </Box>
                    <Body size={10} weight="light" lineHeight={14}>
                        You also agree to receive Staples promotional
                        communications.
                    </Body>
                    <Body size={10} weight="light" lineHeight={14}>
                        You may unsubscribe at any time.
                    </Body>
                </Box>
            </FullWidthCard>
            <TermsAndPrivecyAndCaliforniaNoticeDrawer
                tabIndex={tosTabIndex}
                tosSource={tosSource}
                showTabs={showTabs}
                onClose={() => {
                    setTosSource(null);
                    setShowTabs(false);
                    setTosTabIndex(0);
                }}
                onChange={(_e, value) => {
                    setTosTabIndex(value);
                    if (value === 0) {
                        setTosSource(
                            `${process.env.REACT_APP_DOTCOM_URL}/hc?id=52e40651-0852-4ad7-a532-45017c287d50`
                        );
                    } else {
                        setTosSource(
                            `${process.env.REACT_APP_DOTCOM_URL}/lp/easy-rewards-terms-conditions`
                        );
                    }
                }}
            />
        </>
    );
};

export default NoEnrollEasyRewardCard;
